import { render, staticRenderFns } from "./emissions.vue?vue&type=template&id=2f4a22c0"
import script from "./emissions.vue?vue&type=script&lang=js"
export * from "./emissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4a22c0')) {
      api.createRecord('2f4a22c0', component.options)
    } else {
      api.reload('2f4a22c0', component.options)
    }
    module.hot.accept("./emissions.vue?vue&type=template&id=2f4a22c0", function () {
      api.rerender('2f4a22c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/emissions.vue"
export default component.exports